import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface ConvertToSupplementaryDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export const ConvertToSupplementaryDialog = ({
  isOpen,
  onClose,
  onConfirm,
}: ConvertToSupplementaryDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Convert to Supplementary Report</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to convert this report to a supplementary
          report?
        </DialogContentText>
        <DialogContentText>
          <br />
          You will need to link this report to an original report in the next
          step.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "16px",
        }}
      >
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={() => onConfirm()} color="primary" variant="contained">
          Convert
        </Button>
      </DialogActions>
    </Dialog>
  );
};
